import { useState, useEffect } from 'react';

const LANGUAGE_KEY = 'language';

export default function useLanguage() {
    const [language, setLanguage] = useState('vi');

    useEffect(() => {
        const storedLang = localStorage.getItem(LANGUAGE_KEY);
        if (storedLang) {
            setLanguage(storedLang);
        }
    }, []);

    const changeLanguage = (lang) => {
        setLanguage(lang);
        localStorage.setItem(LANGUAGE_KEY, lang);
        window.location.reload();
    };

    return { language, changeLanguage };
}
